import { NavLink } from 'react-router-dom';
import './notFound.scss';

const NotFound = () => (
    <main className="not_found">
        <p className="not_found_code">404</p>
        <h1>Page not found</h1>
        <p>The page you requested does not exist.</p>
        <NavLink className="not_found_link" to="/">Return home</NavLink>
    </main>
);

export default NotFound;